<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div mat-dialog-title *ngIf='tenantPermissions'>

  <h2
    style="font-family: Roboto, 'Helvetica Neue', sans-serif;">{{tenantPermissions.tenantPermissionsId ? "Edit" : "Create"}}
    Edition</h2>
</div>


<div mat-dialog-content>

  <div class="editUser"
       *ngIf='tenantPermissions'
       style="margin: 10px 10px 10px 10px">
    <div>
      <alert></alert>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div style="flex:20%">
        <mat-form-field class="example-full-width">
          <mat-label>Edition</mat-label>
          <input matInput

                 name="name"
                 [(ngModel)]="tenantPermissions.name"
          >
        </mat-form-field>
      </div>
      <div style="flex:80%">
        <mat-form-field class="example-full-width" style="width: 100%;">
          <mat-label>Description</mat-label>
          <input matInput

                 name="name"
                 [(ngModel)]="tenantPermissions.description"
          >
        </mat-form-field>
      </div>
    </div>

    <div style="display: flex; flex-direction: row;">
      <div style="flex:100%">
        <h3>Expiration</h3>
        <div style="display: flex; flex-direction: row;">
          <div style="flex:33%; height:58px;padding-top:10px">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.expires"
            >Expires
            </mat-checkbox>
          </div>
          <div style="flex:50%">
            <mat-form-field class="example-full-width" *ngIf="tenantPermissions.expires">
              <mat-label># of days</mat-label>
              <input matInput

                     name="expirationDuration"
                     [(ngModel)]="tenantPermissions.expirationDuration"
              >
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div style="flex:100%">
        <h3>Features</h3>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="API"
              [(ngModel)]="tenantPermissions.isAPIEnabled"
            >API
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isCloneEnabled"
            >Clone
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isTrainingEnabled"
            >Awareness
            </mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isPracticeGuidanceEnabled"
            >Advisor Guidance
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isPolicyVersionEnabled"
            >Policy Version
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isPdfReportsEnabled"
            >PDF Reports
            </mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isLoggingEnabled"
            >Logging
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isProjectsEnabled"
            >Projects
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isControlsEnabled"
            >Controls
            </mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isAuditEnabled"
            >Audits
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isRisksEnabled"
            >RizkList
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isImplementationControlStatementsEnabled"
            >Implementation Control Statements
            </mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isAzureAuthenticationEnabled"
              [(ngModel)]="tenantPermissions.isAzureAuthenticationEnabled"
            >Azure AD Authentication
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isOidcAuthenticationEnabled"
              [(ngModel)]="tenantPermissions.isOidcAuthenticationEnabled"
            >OIDC Authentication
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isWorkstreamsEnabled"
              [(ngModel)]="tenantPermissions.isWorkstreamsEnabled"
            >Workstreams
            </mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isOwnAmazonStorageEnabled"
              [(ngModel)]="tenantPermissions.isOwnAmazonStorageEnabled"
            >Own Amazon Storage
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="IsOwnAzureStorageEnabled"
              [(ngModel)]="tenantPermissions.IsOwnAzureStorageEnabled"
            >Own Azure Storage
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="expires"
              [(ngModel)]="tenantPermissions.isMappingTemplateEnabled"
            >Mapping Templates
            </mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isEditICSAndAPEnabled"
              [(ngModel)]="tenantPermissions.isEditICSAndAPEnabled"
            >Upload ICS-GAP Defaults
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isSecurityAssessmentTabnabled"
              [(ngModel)]="tenantPermissions.isSecurityAssessmentTabEnabled"
            >Security Assessment Tab
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isRiskAssessmentTabEnabled"
              [(ngModel)]="tenantPermissions.isRiskAssessmentTabEnabled"
            >Risk Assessment Tab
            </mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isRizkMapEnabled"
              [(ngModel)]="tenantPermissions.isRizkMapEnabled"
            >RizkMap
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isAWSMeteringEnabled"
              [(ngModel)]="tenantPermissions.isAWSMeteringEnabled"
            >AWS Metering
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox
              name="isTrustBuilderEnabled"
              [(ngModel)]="tenantPermissions.isTrustBuilderEnabled"
            >Trust Builder
            </mat-checkbox>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox name="isElixirEnabled"
                          [(ngModel)]="tenantPermissions.isElixirEnabled">
              Elixir
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox name="isSspEnabled"
                          [(ngModel)]="tenantPermissions.isSspEnabled">
              SSP Generation
            </mat-checkbox>
          </div>
          <div style="height:58px;padding-top:10px; flex:1 1 33%">
            <mat-checkbox name="isAutonomyEnabled"
                          [(ngModel)]="tenantPermissions.isAutonomyEnabled">
              Fleet Mode
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div style="flex:100%">
        <h3>Limits</h3>
        <div style="display: flex; flex-direction: row;">
          <div style="flex:1 1 20%; padding-right: 10px;">
            <mat-form-field class="example-full-width">
              <mat-label>Projects</mat-label>
              <input matInput

                     name="expirationDuration"
                     [(ngModel)]="tenantPermissions.maxProjects"
              >
            </mat-form-field>
          </div>
          <div style="flex:1 1 20%">
            <mat-form-field class="example-full-width">
              <mat-label>Users</mat-label>
              <input matInput

                     name="expirationDuration"
                     [(ngModel)]="tenantPermissions.maxUsers"
              >
            </mat-form-field>
          </div>
          <div style="flex:1 1 20%; padding-right: 10px;">
            <mat-form-field class="example-full-width">
              <mat-label>Awareness Users</mat-label>
              <input matInput

                     name="expirationDuration"
                     [(ngModel)]="tenantPermissions.maxTrainingUsers"
              >
            </mat-form-field>
          </div>
          <div style="flex:1 1 20%; padding-right: 10px;">
            <mat-form-field class="example-full-width">
              <mat-label>Partner Users</mat-label>
              <input matInput

                     name="maxPartnerUsers"
                     [(ngModel)]="tenantPermissions.maxPartnerUsers"
              >
            </mat-form-field>
          </div>
          <div style="flex:1 1 20%; padding-right: 10px;">
            <mat-form-field class="example-full-width">
              <mat-label>Survey Users</mat-label>
              <input matInput

                     name="maxSurveyUsers"
                     [(ngModel)]="tenantPermissions.maxSurveyUsers"
              >
            </mat-form-field>
          </div>
          <div style="flex:1 1 20%; padding-right: 10px;">
            <mat-form-field class="example-full-width">
              <mat-label>Profiles</mat-label>
              <input matInput

                     name="expirationDuration"
                     [(ngModel)]="tenantPermissions.maxProfiles"
              >
            </mat-form-field>
          </div>
          <div style="flex:1 1 20%">
            <mat-form-field class="example-full-width">
              <mat-label>Surveys</mat-label>
              <input matInput

                     name="expirationDuration"
                     [(ngModel)]="tenantPermissions.maxSurveys"
              >
            </mat-form-field>
          </div>
        </div>
        <div>
          <div style="flex:20%">
            <mat-form-field class="example-full-width">
              <mat-label>Inactivity Timeout</mat-label>
              <input matInput

                     name="inactivityTimeout"
                     [(ngModel)]="tenantPermissions.inactivityTimeout"

              >
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div>
      <label style="color: rgba(0,0,0,.54)">Login text</label>
      <p-editor [(ngModel)]="tenantPermissions.loginAlert"
                type="text"
      >

        <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
          <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
          <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
          <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                    <button class="ql-indent" value="-1"></button>
                    <button class="ql-indent" value="+1"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
            <!--button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                    (click)="selectDocument(el)">D</button-->
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
          <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
          <!--span class="ql-formats">
                      <button aria-label="" class="pi pi-table better-table"
                              style="font-family: 'primeicons';"></button>
                    </span-->
        </p-header>
      </p-editor>
    </div>

    <mat-tab-group>
      <mat-tab label="Frameworks">
        <p-table [value]="complianceAreas"
                 [paginator]="false"
                 [style]="{'margin-top':'10px'}"
                 [selectionMode]="'multiple'"
                 [(selection)]="selectedComplianceAreas"
        >
          <ng-template pTemplate="header">
            <tr style="white-space: nowrap; font-weight: bold;">
              <th>Name</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
                {{item.name}}</td>
            </tr>
          </ng-template>
        </p-table>

      </mat-tab>
      <mat-tab label="Policies & Procedures">
        <p-table [value]="policies" [(selection)]="selectedPolicies"
                 dataKey="id" selectionMode="multiple"
        >
          <ng-template pTemplate="body" let-item let-expanded="expanded" let-i="rowIndex">
            <tr>
              <td style="width:2em;" [pRowToggler]="item">
                    <span>
                      <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                    </span>
              </td>
              <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
                {{item.name}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="expandedrow" let-item let-i="rowIndex">
            <tr>
              <td [colSpan]="2">
                <div [innerHTML]="item.text | sanitizeHtml"></div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </mat-tab>
      <mat-tab label="Profiles & Surveys">
        <p-table [value]="profiles"
                 [paginator]="false"
                 [style]="{'margin-top':'10px'}"
                 [selectionMode]="'multiple'"
                 [(selection)]="selectedProfiles"
        >
          <ng-template pTemplate="header">
            <tr style="white-space: nowrap; font-weight: bold;">
              <th>Name</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
                {{item.name}}</td>
            </tr>
          </ng-template>
        </p-table>
        <p-table [value]="assessments"
                 [paginator]="false"
                 [style]="{'margin-top':'10px'}"
                 [selectionMode]="'multiple'"
                 [(selection)]="selectedAssessments"
        >
          <ng-template pTemplate="header">
            <tr style="white-space: nowrap; font-weight: bold;">
              <th>Name</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
                {{item.quizData.name}}</td>
            </tr>
          </ng-template>
        </p-table>

      </mat-tab>

      <mat-tab label="Courses">
        <p-table [value]="trainings"
                 [paginator]="false"
                 [style]="{'margin-top':'10px'}"
                 [selectionMode]="'multiple'"
                 [(selection)]="selectedTrainings"
        >
          <ng-template pTemplate="header">
            <tr style="white-space: nowrap; font-weight: bold;">
              <th>Name</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
                {{item.quizData.name}}</td>
            </tr>
          </ng-template>
        </p-table>

      </mat-tab>

      <mat-tab label="Audits">
        <p-table [value]="audits"
                 [paginator]="false"
                 [style]="{'margin-top':'10px'}"
                 [selectionMode]="'multiple'"
                 [(selection)]="selectedAudits"
        >
          <ng-template pTemplate="header">
            <tr style="white-space: nowrap; font-weight: bold;">
              <th>Name</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
                {{item.name}}</td>
            </tr>
          </ng-template>
        </p-table>

      </mat-tab>

      <mat-tab label="Mapping Templates">
        <p-table [value]="mappingTemplates"
                 [paginator]="false"
                 [style]="{'margin-top':'10px'}"
                 [selectionMode]="'multiple'"
                 [(selection)]="selectedMappingTemplates"
        >
          <ng-template pTemplate="header">
            <tr style="white-space: nowrap; font-weight: bold;">
              <th>Name</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
                {{item.name}}</td>
            </tr>
          </ng-template>
        </p-table>

      </mat-tab>

    </mat-tab-group>


  </div>
</div>
<div mat-dialog-actions>
  <div style="display: flex; flex-direction: row; justify-content: start; align-items: start">
    <button mat-raised-button
            style="border-radius: 6px;"
            (click)="onSave()">Save
    </button>
    <button mat-raised-button
            style="border-radius: 6px;"
            (click)="onClose()">Cancel
    </button>
  </div>
</div>
